import { render, staticRenderFns } from "./ReviewsTitle.vue?vue&type=template&id=28873631&scoped=true"
import script from "./ReviewsTitle.vue?vue&type=script&lang=js"
export * from "./ReviewsTitle.vue?vue&type=script&lang=js"
import style0 from "./ReviewsTitle.vue?vue&type=style&index=0&id=28873631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28873631",
  null
  
)

export default component.exports